import React from 'react';

import { ActionIcon, Popover, PopoverProps } from '@mantine/core';
import { IconAlertSquare } from '@tabler/icons-react';

const WarningButton = ({ children, ...props }: PopoverProps): JSX.Element => {
  return (
    <Popover shadow='lg' radius='md' withArrow {...props}>
      <Popover.Target>
        <ActionIcon variant='subtle' color='yellow'>
          <IconAlertSquare />
        </ActionIcon>
      </Popover.Target>
      <Popover.Dropdown>{children}</Popover.Dropdown>
    </Popover>
  );
};

export default WarningButton;
